
import Footer from "@/components/lyx-components/lyx-footer/index"
import Swiper from "swiper";
import loading from "@/components/public-components/loading/index.vue";
import imagePreview from "@/components/lyx-components/image-preview/index";
import videoBox from '@/components/lyx-components/videoStart/videoStart.vue'
import util from '@/javascript/util'
import Previewer from 'vux/src/components/previewer/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import mapUtil from '@/javascript/mapUtil'
import EsQuery from '@/javascript/esQuery'
import collect from '@/components/public-components/collect/index.vue'
import { formatDate } from "@/javascript/formatDate"

import scienceCom from '@/components/public-components/scienceComment/index.vue'
import bus from '@/javascript/bus'
import goBack from '@/components/public-components/goBack/index.vue'

import payPublic from '@/javascript/payPublic'

import mapList from '@/components/public-components/mapList/index.vue'

export default {
components: {
Footer,
loading,
imagePreview,
videoBox,
Previewer,
collect,
scienceCom,
goBack,
mapList,
},
data () {
return {
showMapList: false,
nessaryDatas: [],//必去景点

descriptionLength: '',
isWeixin: util.isWeiXin(),

openState: true,

jtMapShow: false,

videoShow: false,
totalElements:0,

videoUrl: '',
videoUrls: [],

mapLink: '',

scenicData: {
scenicEntity: { title: "" },
fileList: { image: { all: { materials: [{ fileUrl: '' }] } }, video: { all: { materials: [{ fileUrl: '' }] } } },
businessEntity: {}
},
minHeight: 0,
pageNum:5,
infiniteAll: true,
serviceData: [
{ number: 119015, name: "电子导览" },
{ number: 119016, name: "语音讲解" },
{ number: 119001, name: "停车场" },
{ number: 119003, name: "观景台" },
{ number: 119006, name: "空调" },
{ number: 119018, name: "游客中心" },
{ number: 119020, name: "餐厅" },
{ number: 119004, name: "免费WIFI" },
{ number: 119019, name: "自助导游" },
{ number: 119017, name: "视频讲解" },
{ number: 119022, name: "木屋" },
{ number: 119025, name: "帐篷" },
],
newObj: [
{
code: '00000000,1608715065876,1608715115733',
id: '2b01c60f473749479e1f5e1db7eb1496'
},
{
id: '337ef42b438542579207d19c51664222',
code: '00000000,1608715065876,1608715095824'
},
],
newData: null,
foodList: [],
nessaryData: [], // 美食列表

commentList: [],

weatherData: '',

ID: '',
gallery: [],
time: false,
passWord: {
identiferId: '',
articleSite: '',
moduleCode: this.AREA_CODE.AREACODE,
collTypes: this.XQSC_TYPE_CODE.JQ,
name: '',
appCode: 62
},
senictitle: '',
wxLink: false,
parkData: null,
url: "",
screenWidth: 0,

ticketList: {},
ticketURL: "https://wap.lotsmall.cn/vue/detail/ticket?id=3106&m_id=290", // 门票购买链接
};
},
computed: {
videoShow2 () {
return this.videoShow
}
},
methods: {
viewMore(){
if(this.pageNum>=this.totalElements){
return
}
this.pageNum+=5
this.feachDetails()
},

gotoPageUrl(href, ticketId) {
if (!href) return false;
const query = {
scenicId: this.$route.params.id,
ticketId: ticketId,

};
this.$router.push({ path: "/tickethjly", query: query });
},

callPhone () {
if (this.scenicData && this.scenicData.businessEntity.phone != "暂无" && this.scenicData.businessEntity.phone) {
payPublic.callPhone(this.scenicData.businessEntity.phone)
} else {
payPublic.showPrompt(`暂无电话`)
}
},
gerScreenFun () {
if (window.screen.width == 1080) {  //1080*1920
this.screenWidth = 2
} else if (window.screen.width == 1920) {  //1920*1080
this.screenWidth = 1
} else {
this.screenWidth = 0
}
},
/**
* @msg: 停车位信息
* @param {*}
* @return {*}
*/
getParkData (code) {
this.$http.get('/daapi/park/getParkInfo').then(res => {
const data = res.data.data
if (data) {
data.map(item => {
if (item.parkCode == code) {
this.parkData = item

}
})
}
})
},
getNew () {
let newObj = {}
if (this.$route.query.id == '43f8eb42ad894852b6c25734ad70d6f9') {
newObj = this.newObj[0]
} else if (this.$route.query.id == '97560e95863442c29aee720ce387c25c') {
newObj = this.newObj[1]
} else {
return
}
const querystring = require('querystring')
const newEsQuery = new EsQuery()
newEsQuery.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newEsQuery.and, false)
.addStartWith('catalogCode', newObj.code, newEsQuery.and, false)
.addString('catalogId', newObj.id, newEsQuery.and, false)
.addPage(0, 10)
const newEsJsonQuery = JSON.stringify(newEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': this.INDEX_NAME_TYPE.newsList,
'esJsonQuery': newEsJsonQuery
})).then(res => {
const data = res.data.data
if (data) {
this.newData = data.map(item => item._source)[0]
}
})

},


getWeather (cityCodeList, i) {
if (i > cityCodeList.length - 1) {
return
}
this.$http.get('/api/wtcp-weather/public/weather/detail/1/' + cityCodeList[i]).then(res => {
if (res.data.data && res.data.data.today) {
this.weatherData = res.data.data && res.data.data.today ? res.data.data.today : ''
} else {
i++
this.getWeather(cityCodeList, i)
}
})
},

videoClick (url) {

this.videoShow = true
this.videoUrls = url
},

goGuide () {
this.$router.push('/guideOne/' + this.$route.params.id)
},

getMapLink (service) {
if (service.indexOf('119015') > -1) {
this.$set(this, 'mapLink', '/itelgeGuide/' + this.scenicData.scenicEntity.id)
}
},
seeMore () {
this.infiniteAll = !this.infiniteAll;
},

feachDetails () {
let self = this
let nowTitle = ''

self.$http.get('/api/wtcp-bics/public/scenic/getOne/' + self.$route.params.id).then((res) => {
self.scenicData = res.data.data
document.title = self.scenicData.scenicEntity.title;

self.gallery = res.data.data.fileList.image.all.materials.map(item => {
if (item.fileUrl && item.fileUrl.indexOf('\\') != -1) {
item.fileUrl = item.fileUrl.replaceAll("\\", "/\/")
}
item.src = self.PIC_BASE_URL + item.fileUrl
return item
})

const scenicData = res.data.data,
scenicEntity = scenicData.scenicEntity,
fileList = scenicData.fileList;
self.videoUrls = res.data.data.fileList.video.all.materials.map(item => {
if (item.fileUrl && item.fileUrl.indexOf('\\') != -1) {
item.fileUrl = item.fileUrl.replaceAll("\\", "/\/")
}
if (item.coverImageUrl && item.coverImageUrl.indexOf('\\') != -1) {
item.coverImageUrl = item.coverImageUrl.replaceAll("\\", "/\/")
}
item.src = self.PIC_BASE_URL + item.fileUrl
item.coverImageUrl = self.PIC_BASE_URL + item.coverImageUrl
item.fileName = item.fileName.replaceAll('.mp4', '')
return item
})
let openTime = (scenicEntity.summerTime.indexOf(',') != -1) ? scenicEntity.summerTime.split(',') : ['00:00', '24:00'];
let openTime1 = (scenicEntity.winterTime.indexOf(',') != -1) ? scenicEntity.winterTime.split(',') : ['00:00', '24:00'];
let areaName = scenicEntity.regionFullName.split(','),
n = new Date,
s = new Date,
e = new Date,
startTime = openTime[0].split(':'),
endTime = openTime[1].split(':')

s.setHours(startTime[0])
s.setMinutes(startTime[1])
e.setHours(endTime[0])
e.setMinutes(endTime[1])
scenicEntity.openState = (n.getTime() > s.getTime() && n.getTime() < e.getTime()) ? '开园中 | ' + openTime[1] + '闭园' : '闭园中 | ' + openTime[0] + '开园'
self.descriptionLength = self.scenicData.scenicEntity.content.length;
nowTitle = res.data.data.scenicEntity.title
scenicEntity.times = scenicData.scenicEntity.summerTime.split(',')[0] + ' - ' + scenicData.scenicEntity.summerTime.split(',')[1]
scenicEntity.mapGu = fileList.image && fileList.image.mark.materials[0] ? fileList.image.mark.materials[0].fileUrl : "";

scenicEntity.serviceType = 400
self.passWord.identiferId = scenicEntity.id
self.passWord.name = scenicEntity.title
self.passWord.picUrl = scenicEntity.bg

if (util.isWeiXin()) {
const shareData = typeof (shareData) === 'undefined' ? {
title: this.PAGE_TITLE + "导览",
desc: '圣湖之光，大景海晏，海晏欢迎您~~',
imgUrl: window.location.origin + '/static/-img/banner_img.png',
link: window.location.href
} : shareData;
this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
util.initWxConfig(response.data.data, shareData)
})
}

if (bus.userInfo.user) {
const userInfo = bus.userInfo.user,
history = {
catalog: this.XQSC_TYPE_CODE.JQ,
serviceType: this.SERVICE_TYPE.JQ,
title: scenicEntity.title,
url: this.$route.path,
userId: userInfo.id,
username: userInfo.username,
picUrl: scenicEntity.titleImage || scenicData.fileList.image.all.materials[0].fileUrl
}
bus.$set(bus, 'history', history)
} else {
console.log('token过期了呀');
}

if (scenicData.businessEntity && scenicData.businessEntity.serviceFacility) {
this.serviceData.service = this.serviceData.filter(item => scenicData.businessEntity.serviceFacility.indexOf(item.number) + 1)
this.getMapLink(scenicData.businessEntity.serviceFacility)
}
}).then(() => {

this.$http.get(
"/api/wtcp-bics/public/poi/getList/" +
this.$route.params.id +
"?type=127001"
)
.then((res) => {
const attrsData = res.data.data,
attractions = attrsData.map((attraction) => {
attraction.poiEntity.titimg =
attraction.fileList.image &&
attraction.fileList.image.titleImage.materials[0]
? attraction.fileList.image.titleImage.materials[0].fileUrl
: attraction.fileList.image.all.materials[0].fileUrl;
return attraction.poiEntity;
});
this.$set(this, "nessaryDatas", attractions);
}).then(() => {
let weatherCode = this.scenicData.scenicEntity.regionFullCode.split(',').reverse()
this.getWeather(weatherCode, 0)
this.$nextTick(() => {
new Swiper('.nessary-view', {
slidesPerView: 'auto',
spaceBetween: 20,
freeMode: true,
observer: true,
observeParents: true
});
})

}).then(() => {



this.$http.get('/api/wtcp-comment/public/evaluation/findEvaluationAndReplyPage?appCode=62&identifer=' + this.$route.params.id + '&moduleCode=' + this.passWord.moduleCode + '&page=0&size='+this.pageNum + '&deptCode=' + this.DEPT_CODE.DEPTCODE).then((response) => {
if (response.data.data && response.data.data.evalPage) {
const commentList = response.data.data.evalPage.content
commentList.forEach(item => item.createDate = formatDate(item.createDate, 'yyyy-MM-dd'))
this.$set(this, 'commentList', commentList)
this.$set(this, 'totalElements', response.data.data.evalPage.totalElements)
}
})

})
})
},


getTickteData() {
this.$http.get(`/api/wtcp-ecrm/public/scenicTicket/findByScenicId?scenicId=${this.$route.params.id}`)
.then((res) => {
const data = res.data.data;
this.ticketList = data;
});
}



},
mounted () {
this.minHeight = document.documentElement.clientHeight

this.feachDetails();
new Swiper(".play-travel-recode", {
slidesPerView: "auto",
spaceBetween: 10,
freeMode: true,
observer: true,
observeParents: true
});

this.passWord.articleSite = window.location.pathname + window.location.hash
this.getNew()

},
watch: {   //监听路由变化
$route (to, from) {

this.feachDetails()
}
},
created () {
const _this = this
window.parent.scrollTo(0, 0);


let ua = navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == "micromessenger") {

wx.miniProgram.getEnv((res) => {
if (res.miniprogram) {
_this.wxLink = true
} else {
console.log("不在小程序里");
}
})
} else {
_this.wxLink = false
console.log('不在微信里');
}
_this.gerScreenFun()
}
};
